import { render, staticRenderFns } from "./MarcaVehiculo.vue?vue&type=template&id=32dc4a71&scoped=true&"
import script from "./MarcaVehiculo.vue?vue&type=script&lang=js&"
export * from "./MarcaVehiculo.vue?vue&type=script&lang=js&"
import style0 from "./MarcaVehiculo.vue?vue&type=style&index=0&id=32dc4a71&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dc4a71",
  null
  
)

export default component.exports